export default __webpack_public_path__ + "static/media/232.8bcf0dea.jpg";